import { render } from "./NewsDeleteModal.vue?vue&type=template&id=cb4c9eda&scoped=true"
import script from "./NewsDeleteModal.vue?vue&type=script&lang=js"
export * from "./NewsDeleteModal.vue?vue&type=script&lang=js"

import "./NewsDeleteModal.vue?vue&type=style&index=0&id=cb4c9eda&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4c9eda"]])

export default __exports__